import { QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { SessionExpiredDialog } from '@/components/auth/SessionExpiredDialog';
import { ModalProvider } from '@/components/ui/modal-provider';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, TestAuthProvider } from '@/context/AuthContext';
import { ThemeProvider } from '@/context/ThemeContext';
import queryClient from '@/lib/queryClient';
import Pages from '@/pages/Routes';
import './App.css';

const clearLegacyAuth0Storage = () => {
    Object.keys(window.localStorage)
        .filter((key) => key.startsWith('@@auth0spajs@@'))
        .forEach((key) => window.localStorage.removeItem(key));
};

const App: React.FC = () => {
    const isTestMode = import.meta.env.MODE === 'test';
    const AppAuthProvider = isTestMode ? TestAuthProvider : AuthProvider;

    React.useEffect(() => {
        clearLegacyAuth0Storage();
    }, []);

    return (
        <ThemeProvider>
            <QueryClientProvider client={queryClient}>
                <AppAuthProvider>
                    <ModalProvider>
                        <Pages />
                        <Toaster />
                        <SessionExpiredDialog />
                    </ModalProvider>
                </AppAuthProvider>
            </QueryClientProvider>
        </ThemeProvider>
    );
};

export default App;
